import { BOPIS_MSG_GET_REQUEST, RESET_BOPIS_MESSAGE } from '../actionTypes/BOPISMessageActionTypes';

const getBOPISMessage = () => ({
    type: BOPIS_MSG_GET_REQUEST,
});

const resetBOPISMessage = () => ({
    type: RESET_BOPIS_MESSAGE,
});
export default { getBOPISMessage, resetBOPISMessage };
